import React from 'react';
import { Icon, Margin, Text } from '@upgrade/react-components';
import { Link } from 'gatsby';
import { ImgPlaceholder } from '../styles';
import Image from '../../Image';

const SubMenuItem = ({ to, onClick, onKeyDown, icon, label, bgPosition, img, bold, marginRight }) => {
  return (
    <li role="none">
      <Link
        {...{
          to,
          role: 'menuitem',
          onClick,
          onKeyDown,
          activeClassName: to ? 'active' : ''
        }}
      >
        {icon && (
          <Text>
            <Margin className="hidden-md" right="sm">
              <Icon aria-hidden align="middle" icon={icon} size="1.5rem" color="actionablePrimary" />
            </Margin>
          </Text>
        )}
        <Margin right={marginRight}>
          <Text bold={bold} marginBottom="none">
            {label}
          </Text>
        </Margin>
        {bgPosition && <ImgPlaceholder aria-hidden bgPosition={bgPosition} className="hidden visible-md" />}
        {img && <Image aria-hidden src={img.src} width={40} height={40} className="hidden visible-md" />}
      </Link>
    </li>
  );
};

export default SubMenuItem;
